import { SET_NEWS } from "../../constants/newsConstants";


const initiateState = {
  news: null
};

const newsReducer = (state= initiateState, action) => {
  switch (action.type){
    case SET_NEWS:
      return{
        ...state,
        news: action.news
      }
    default:
      return state;
  }
}

export default newsReducer;